import React, { useContext, useEffect, useRef, useState } from 'react';
import styles from './AcfLottie.module.scss';
import className from 'classnames/bind';
import { gql } from '@apollo/client';
import Lottie from 'lottie-react';
import { NetspendContext } from 'library/contexts/NetspendContext';

let cx = className.bind(styles);

export default function AcfLottie(props) {
	const { lottie, attributes, clientId } = props;
	const className = attributes.className?.split(' ') || [];
	const lottieRef = useRef(null);
	const lottieContainerRef = useRef(null);
	const { carouselLotties } = useContext(NetspendContext);
	const [isVisible, setIsVisible] = useState(false);
	const style = {};
	style['--maxWidthMobile'] = lottie.mobileSettings.maxWidth && `${lottie.mobileSettings.maxWidth}px`;
	style['--maxWidthDesk'] = lottie.desktopSettings.maxWidth && `${lottie.desktopSettings.maxWidth}px`;
	style['--translateXMobile'] = lottie.mobileSettings.translateHorizontal && `${lottie.mobileSettings.translateHorizontal}%`;
	style['--translateYMobile'] = lottie.mobileSettings.translateVertical && `${lottie.mobileSettings.translateVertical}%`;
	style['--translateXDesk'] = lottie.desktopSettings.translateHorizontal && `${lottie.desktopSettings.translateHorizontal}%`;
	style['--translateYDesk'] = lottie.desktopSettings.translateVertical && `${lottie.desktopSettings.translateVertical}%`;


	useEffect(() => {
		const observer = new IntersectionObserver(
			([entry]) => {
				setIsVisible(entry.isIntersecting);
			},
			{
				root: null, // viewport
				rootMargin: '0px', // no margin
				threshold: 0.3, // 30% of target visible
			}
		);

		if (lottieRef.current) {
			lottieRef.current.setSpeed(lottie.speed);
			if (Array.isArray(lottie.mode) && lottie.mode[0] === 'carousel') {
				carouselLotties.current = { ...carouselLotties.current, [clientId]: lottieRef.current };
			}
		}
		if (lottieContainerRef.current && Array.isArray(lottie.mode) && lottie.mode[0] === 'scroll') {
			observer.observe(lottieContainerRef.current);
		}
		return () => {
			if (Array.isArray(lottie.mode) && lottie.mode[0] === 'carousel') {
				const tempLottiesObj = { ...carouselLotties.current };
				delete tempLottiesObj[clientId];
				carouselLotties.current = tempLottiesObj;
			}
			if (lottieContainerRef.current && Array.isArray(lottie.mode) && lottie.mode[0] === 'scroll') {
				observer.unobserve(lottieContainerRef.current);
			}
		};
	}, []);

	useEffect(() => {
		isVisible === true ? lottieRef.current?.play() : lottieRef.current?.stop();
	}, [isVisible]);

	return (
		<>
			<div id={`lottie-${clientId}`} data-lottieid={clientId} className={cx(['ns_lottie-container', 'lottie-container', ...className, lottie.hideOn?.includes('desktop') && 'hidden-desk', lottie.hideOn?.includes('mobile') && 'hidden-mobile', attributes.alignLottie && `align-${attributes.alignLottie}`, lottie.mobileSettings.positionAbsolute && 'position-absolute-mobile', lottie.desktopSettings.positionAbsolute && 'position-absolute-desk'])} style={style} ref={lottieContainerRef}>
				<div>{lottie.file?.node?.mediaItemUrl && <Lottie options={{path: lottie.file.node.mediaItemUrl}} className={cx(['lottie'])} path={lottie.file.node.mediaItemUrl} autoplay={Array.isArray(lottie.mode) && lottie.mode[0] === 'autoplay' ? true : false} loop={lottie.loop} lottieRef={lottieRef} />}</div>
			</div>
		</>
	);
}

AcfLottie.fragments = {
	key: `AcfLottieFragment`,
	entry: gql`
		fragment AcfLottieFragment on AcfLottie {
			attributes {
				alignLottie: align
				anchor
				className
			}
			clientId
			lottie {
				desktopSettings {
					maxWidth
					positionAbsolute
					translateHorizontal
					translateVertical
				}
				hideOn
				loop
				mobileSettings {
					maxWidth
					positionAbsolute
					translateHorizontal
					translateVertical
				}
				mode
				speed
				file {
          node {
            mediaItemUrl
          }
        }
			}
		}
	`,
};

AcfLottie.config = {
	name: 'AcfLottie',
};
AcfLottie.displayName = 'AcfLottie';